import { Dropdown, Icon, Icons, Tooltip } from '@silverfort/sf-components';
import { FC, useMemo } from 'react';
import { QueryFilters, useGetDomains } from '../../api';
import { Timeframe } from '../../types';

import { getLastSyncTooltipText } from '../../utils/utils';

interface FiltersProps {
    filters: QueryFilters;
    onFiltersChange: (filters: QueryFilters) => void;
    excludedCaptureClassName?: string;
    lastSync?: Date;
}

const TIMEFRAMES: Timeframe[] = ['7', '14', '30', '90'];
const DEFAULT_TIMEFRAME = '30';
const TIMEFRAME_ITEMS = [...TIMEFRAMES.map((t) => ({ value: t, title: `${t} days` }))];

const Filters: FC<FiltersProps> = ({ filters, onFiltersChange, excludedCaptureClassName = '', lastSync }) => {
    const { data: domains } = useGetDomains();
    const domainItems = useMemo(() => [...(domains ?? []).map((d) => ({ value: d, title: d }))], [domains]);

    return (
        <div className="flex flex-row gap-2 items-center">
            <Dropdown
                variant="filter"
                multiple
                searchable
                title="Domain"
                removable={Boolean(filters?.domain?.length)}
                selectedItems={filters.domain}
                onRemove={() => onFiltersChange({ ...filters, domain: [] })}
                items={domainItems}
                onChange={(selectedValues) => {
                    onFiltersChange({ ...filters, domain: selectedValues as string[] });
                }}
                width="232px"
                searchPlaceholder={'Search by name'}
            />
            <Dropdown
                className={
                    filters.timeframe === DEFAULT_TIMEFRAME
                        ? 'bg-sf-white [&]:border-sf-gray-100 [&:hover]:border-sf-gray-400 active:border-sf-gray-800'
                        : ''
                }
                variant="filter"
                multiple={false}
                searchable={false}
                title="Timeframe"
                removable={filters.timeframe !== DEFAULT_TIMEFRAME}
                selectedItems={filters.timeframe}
                items={TIMEFRAME_ITEMS}
                onChange={(selectedValues) => {
                    onFiltersChange({ ...filters, timeframe: selectedValues as Timeframe });
                }}
                onRemove={() => onFiltersChange({ ...filters, timeframe: DEFAULT_TIMEFRAME })}
                width="232px"
            />
            <div className={excludedCaptureClassName}>
                <Tooltip title={getLastSyncTooltipText(lastSync)}>
                    <Icon icon={Icons.Refresh} size={16} className="text-sf-gray-500" />
                </Tooltip>
            </div>
        </div>
    );
};

export default Filters;
